module.exports = __webpack_public_path__ + "img/illustrations-store.8cbe5663.svg";